import * as vars from "./mutations-vars";

export const logout = ({ commit }) => {
  commit(vars.CLEAN_USER);
};

export const setUser = ({ commit }, currentUser) => {
  commit(vars.SET_USER, currentUser);
};
export const isLogin = ({ commit }, st) => {
  commit(vars.SET_STATE, st);
};
export const regionWidthChangedNum = ({ commit }) => {
  commit(vars.regionWidthChangedNum);
};
export const setIsMigratory = ({ commit }, value) => {
  commit(vars.SET_IS_MIGRATORY, value);
};



// WEBPACK FOOTER //
// ./src/store/actions.js